import { Input, InputGroup, Text, VStack } from '@chakra-ui/react'
import React from 'react'

interface ModalInputProps {
  label?: string
  type?: string
  name: string
  height?: string
  placeholder?: string
  isInvalid?: boolean
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  required?: boolean
  isDisabled?: boolean
}

const ModalInput: React.FC<ModalInputProps> = ({
  label,
  type = 'text',
  name,
  height,
  placeholder,
  isInvalid,
  value,
  onChange,
  required,
  isDisabled,
}) => {
  return (
    <VStack align="left" spacing="4px" width="100%">
      {label && (
        <Text textStyle="l-xs" color={required ? 'solid.700' : 'solid.500'} fontWeight={required ? '600' : undefined}>
          {label}
          {required && <Text as="span" color="primary.100"> *</Text>}
        </Text>
      )}
      <InputGroup>
        <Input
          type={type}
          name={name}
          height={height}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          isInvalid={isInvalid}
          isDisabled={isDisabled}
          bg={required ? 'primary.0' : undefined}
          borderColor={required ? 'primary.50' : undefined}
          _focus={required ? { borderColor: 'primary.100', bg: 'white' } : undefined}
        />
      </InputGroup>
    </VStack>
  )
}

export default ModalInput
